module.exports = __webpack_public_path__ + "img/6546.816275eb.jpg";